<template>
  <page-wrapper background="/static/img/anniversary/page-contract-last/bg.png" :swiper="swiper" :hasDownBtn="true">
    <div class="main-text ani" swiper-animate-effect="animate__fadeIn">
      时隔<span class="text-highline">{{data.yearDiff}}</span>之后<br /> <span class="text-highline">{{data.lastContractDate}}</span><br/>
      您再次选择了吉凯基因的 <span class="text-highline">{{data.lastContractProduct}}</span><br/><br/>

      您与吉凯的合作时长超过<span class="collaborationDurationProportion">{{data.collaborationDurationProportion}}</span>用户<br/>被授予<span class="text-ke">科研巨匠</span>称号<br/>
    </div>
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  props: [
    'swiper', 'data'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .collaborationDurationProportion {
    font-size: 22px;
    font-weight: 700;
  }
  .main-text {
    position: absolute;

    left: 50%;
    bottom: 26.66666667vw;
    margin-left: -40.65vw;
    width: 81.3vw;
    font-size: 4.26vw;
    line-height: 9.33vw;
    font-weight: 400;
    letter-spacing: -0.3px;
    z-index: 99;

    /* 字体 */
    color: white;

    .text-highline {
      font-size: 22px;
      font-weight: 600;
    }
     .text-ke {
       color: #FCB317;
       font-size: 22px;
       font-weight: 700;
     }
    .text-notice {
      font-size: 16px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7aea0a05